import { Navigate } from "react-router-dom";
import { useShouldHideSubscriptions } from "../hooks/useShouldHideSubscriptions";
import { Paths } from "./paths";

interface HideSubscriptionsOnIOSProps {
  children: React.ReactNode;
}

/** Blocks subscription / payment routes on iPhone-sized iOS (not iPad). */
export const HideSubscriptionsOnIOS = ({
  children,
}: HideSubscriptionsOnIOSProps) => {
  const hideSubscriptions = useShouldHideSubscriptions();
  if (hideSubscriptions) {
    return <Navigate to={Paths.HOME} replace />;
  }
  return <>{children}</>;
};
